/*
 * @Author: 张天昊
 * @Date: 2024-06-05 16:15:51
 * @LastEditTime: 2024-07-10 13:53:38
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/router/navigate.js
 */
export function navigateToItineraryUniversal(id, scene) {
  const query = scene ? `?scene=${scene}` : ''
  window.yyn.invokeJSB('openWindow', {
    openUrl: `${window.location.origin}/web/#/itineraryUniversal/detail/${id}${query}`,
    isFullScreen: 1,
    hiddenTitleBar: true,
    needLoading: 1
  });
}
